var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5894 -569)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Moon_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Moon_svg__a",
    fill: "#fff",
    transform: "rotate(-28.089 4095.57 -11493.51)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Moon_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Moon_svg__c",
    fill: "#4A4A4A",
    transform: "rotate(-28.089 4095.57 -11493.51)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Moon_svg__a",
    d: "M11.966 17.5c-.93.324-1.927.5-2.966.5A9 9 0 1 1 9 0c1.039 0 2.037.176 2.966.5C7.5 7 7.5 11 11.966 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Moon_svg__c",
    d: "m11.966.5 1.648 1.133 1.483-2.159-2.473-.862zm0 17 .658 1.888 2.473-.862-1.483-2.158zM9 16a7 7 0 0 1-7-7h-4c0 6.075 4.925 11 11 11zM2 9a7 7 0 0 1 7-7v-4C2.925-2-2 2.925-2 9zm7-7a6.2 6.2 0 0 1 2.307.388l1.317-3.776A12 12 0 0 0 9-2zm2.307 13.612A6.2 6.2 0 0 1 9 16v4a12 12 0 0 0 3.624-.612zm-.99-16.244C7.999 2.74 6.617 5.775 6.617 9s1.382 6.259 3.7 9.633l3.297-2.265C11.466 13.24 10.616 11.025 10.616 9s.85-4.241 2.998-7.367z"
  }))));
};
export default SvgMoon;